module.exports = __webpack_public_path__ + "assets/img/PREVENTA_img3.c218d996.png";